<template>
  <div class="page-loading">
    <h4 v-if="isFail" style="border: 1px solid black; padding: 5px;">Erro ao carregar formulário...</h4>
    <h4 v-else>Carregando...</h4>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PageLoading',
  computed: {
    ...mapState({
      isFail: state => state.isFail
    })
  }
}
</script>
